import React from 'react'
import { apiCall, secondaryApi } from './ApiUtils'

const {
    VITE_STRIPE_GA_PROD,
    VITE_STRIPE_GA_ECOM_PROD,
    VITE_STRIPE_SOCIAL_PROD,
    VITE_STRIPE_AC_PROD,
    VITE_STRIPE_PAID_ADS_PROD,
    VITE_STRIPE_WP_PROD,
    VITE_STRIPE_SHOPIFY_PROD,
    VITE_STRIPE_VETERANS_BOOTCAMP_PROD,
    VITE_STRIPE_FRANDEV_BOOTCAMP_PROD
} = import.meta.env

export const getCheckoutSession = (sessionId) => apiCall(`checkout/${sessionId}`, {
    method: 'GET'
}, null, secondaryApi)

export const getTrialExpiredCheckout= (siteId, overrideCancelUrl=null) => apiCall(`checkout/${siteId}/session${overrideCancelUrl ? "?overrideCancelUrl="+ overrideCancelUrl : ""}`, {
    method: 'GET'
}, null, secondaryApi)

export const getCheckoutProducts = (siteId, userViewable=null) => apiCall(`checkout/${siteId ? siteId + "/" : ""}products?${userViewable ? "userViewable=1": ""}`, {
    method: 'GET'
}, null, secondaryApi)


export const getProductSession = (siteId, productId, overrideCancelUrl=null) => apiCall(`checkout/${siteId}/session/${productId}${overrideCancelUrl ? "?overrideCancelUrl="+ overrideCancelUrl : ""}`, {
    method: 'GET'
}, null, secondaryApi)

export const getCheckoutCoupons = (siteId) => apiCall(`checkout/${siteId}/coupons`, {
    method: 'GET'
}, null, secondaryApi)

export const createCheckout = (siteId, items, coupons, sendEmail=true) => apiCall(`checkout/${siteId}/session`, {
    method: 'POST',
    body: {
        items,
        coupons,
        sendEmail
    }
}, null, secondaryApi)

export const userProductMap = {
    [VITE_STRIPE_GA_PROD]: {
        order: 1,
        content: (<>
            <h4>Foundational optimization of core analytics account. <small>This is a one time fee</small></h4><br />
            <ul class="list-unstyled">
                <li class="h4">Block spam and bot traffic</li>
                <li class="h4">Block spam international traffic</li>
                <li class="h4">Block staff &amp; vendor traffic</li>
                <li class="h4">Create goal funnels</li>
                <li class="h4">Optimize account</li>
                <li class="h4">G4 to UA conversion</li>
            </ul>
        </>)
    },
    [VITE_STRIPE_GA_ECOM_PROD]: {
        order: 2,
        content: <>
            <h4>Core optimization plus specific ecommerce tracking. <small>This is a one time fee</small></h4><br />
            <ul className="list-unstyled">
                <li class="h4">Shopping cart optimization</li>
                <li class="h4">Revenue tracking</li>
                <li class="h4">Sales funnel steps</li>
            </ul>
        </>
    },
    [VITE_STRIPE_SOCIAL_PROD]: {
        order: 3,
        content: <>
            <h4>Creation and optimization of four core platforms. <small>This is a one time fee</small></h4><br />
            <ul className="list-unstyled">
                <li class="h4">Facebook business page</li>
                <li class="h4">Instagram for business</li>
                <li class="h4">LinkedIn company page</li>
                <li class="h4">Google Business Profile</li>
            </ul>
        </>
    },
    [VITE_STRIPE_AC_PROD]: {
        order: 5,
        content: <>
            <h4>Setup &amp; implmentation of all 4 core platform features. <small>This is a one time fee</small></h4><br />
            <ul className="list-unstyled">
                <li class="h4">Creation of custom contact fields</li>
                <li class="h4">Creation of AI/SMS contact stats</li>
                <li class="h4">Creation of sales funnel tracking</li>
                <li class="h4">Integration of web forms into AC</li>
                <li class="h4">Core Automation recipes</li>
                <li class="h4">Connection to Insights Engine</li>
            </ul>
        </>
    },
    [VITE_STRIPE_PAID_ADS_PROD]: {
        order: 4,
        content: <>
            <h4>Creation and optimization of these four paid ad platforms. <small>This is a one time fee</small></h4><br />
            <ul className="list-unstyled">
                <li class="h4">Facebook business + Ads manager</li>
                <li class="h4">Facebook page boost setup</li>
                <li class="h4">LinkedIn Ads manager account</li>
                <li class="h4">LinkedIn page boost setup</li>
                <li class="h4">Google Ads account</li>
            </ul>
        </>
    },
    [VITE_STRIPE_WP_PROD]: {
        order: 6,
        content: <>
            <h4>Optimization of Wordpress environment. <small>This is a one time fee</small></h4><br />
            <ul className="list-unstyled">
                <li class="h4">Plugin updates</li>
                <li class="h4">Wordpress updates</li>
                <li class="h4">Spam comment review</li>
                <li class="h4">Security scan</li>
                <li class="h4">Gravity Forms conversion</li>
                <li class="h4">UTM Grabber installation</li>
            </ul>
        </>
    },
    [VITE_STRIPE_SHOPIFY_PROD]: {
        order: 7,
        content: <>
            <h4>Optimization of shopping cart environment. <small>This is a one time fee</small></h4><br />
        </>
    },
    ralio: {
        order: 8,
        content: <>
            <h4>Compliments of our Rallio partners as a thanks to veterans and military spouses.</h4><br />
            <ul className="list-unstyled">
                <li class="h4">Integrated social posting</li>
                <li class="h4">Dedicated resource library</li>
                <li class="h4">Future scheduling feature</li>
                <li class="h4">Social media inbox</li>
                <li class="h4">Social review monitoring</li>
                <li class="h4">Mobile app</li>
            </ul>
        </>
    },
    [VITE_STRIPE_VETERANS_BOOTCAMP_PROD]: {
        order: 9,
        content: <></>
    },
    [VITE_STRIPE_FRANDEV_BOOTCAMP_PROD]: {
        order: 10,
        content: <></>   
    }
}